const EXCLUDED_ROOMS = new Set(['SE01A', 'SE01B', 'SE02A', 'SE02B']);

export const isExcludedOwnerRoom = code => typeof code === 'string' && EXCLUDED_ROOMS.has(code.trim().toUpperCase());

export const isVisibleOwnerProperty = property => !isExcludedOwnerRoom(property?.code);
